import {
  FormControlLabel,
  FormGroup,
  IconButton,
  Popover,
  Switch,
  ToggleButton,
  Tooltip,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { glassColor } from "./Colors";
import {
  AppSettingsAlt,
  SettingsAccessibility,
  SettingsApplications,
  SettingsCell,
} from "@mui/icons-material";

export default function LocalSettings() {
  var [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  var [popoverOpen, setPopoverOpen] = useState(false);

  const [glass, setGlass] = useState<boolean>(
    getSetting<boolean>("use-glass") ?? true
  );

  function getSetting<T>(key: string): T | undefined {
    const value = localStorage.getItem(key);
    if (value === null) {
      return undefined;
    }
    try {
      return JSON.parse(value);
    } catch (e) {
      return value as T;
    }
  }

  function setSetting<T>(key: string, value: T) {
    localStorage.setItem(key, JSON.stringify(value));
  }

  return (
    <div style={{ display: "inline-block", marginRight: "0.5em" }}>
      <Tooltip title="Browser Settings">
        <IconButton
          color="secondary"
          onClick={(event) => {
            setAnchorEl(event.currentTarget);
            setPopoverOpen(true);
          }}
        >
          <AppSettingsAlt />
        </IconButton>
      </Tooltip>

      <Popover
        open={popoverOpen}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        onClose={() => setPopoverOpen(false)}
        sx={{}}
        slotProps={{
          paper: {
            sx: {
              paddingLeft: 2,
              paddingRight: 2,
              paddingTop: 1,
              paddingBottom: 1,
              backgroundColor: glassColor(true, 0.4),
              color: "secondary.main",
              backdropFilter: "blur(10px)",
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              width: "fit-content",
              justifyContent: "space-between",
              overflow: "hidden",
            },
          },
        }}
      >
        <Typography fontWeight={"bold"} fontSize={14}>
          Browser Settings
        </Typography>
        <FormGroup>
          <FormControlLabel
            control={
              <Switch
                color="secondary"
                checked={glass}
                onChange={(event) => {
                  setSetting<boolean>("use-glass", event.target.checked);
                  setGlass(event.target.checked);
                }}
              />
            }
            label="Glass Effect"
          />
        </FormGroup>
      </Popover>
    </div>
  );
}
